import baseApi from "./baseApi"

export default  {
    async getRoles() {
        const request = await baseApi.createHttpRequest();
        const result = await request.get("/roles/roles");
        return result.data;
    },
    async saveRole(role) {
        console.log(role)
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/roles/role", role);
        return result.data;
    },
    async saveRoleRates(rates) {
        console.log(rates)
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/roles/rates", rates);
        return result.data;
    },
    async getSalaryCodes() {
        const request = await baseApi.createHttpRequest();
        const result = await request.get("/salarycodes/salarycodes");
        return result.data;
    },

    /**
     * Fetch Spraies from Server 
     * @return {Array} -- Spraies
     */
    async getSprayConfigurations() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/configuration/spraies");
        return result.data;
    },
    /**
     * Add Spray and return list of spraies
     * @return {Object} 
     */
    async addSprayConfiguration(spray) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put("/configuration/spray", spray);
        return result.data;
    },
    /**
     * Update Spray and return list of spraies
     * @return {Object} 
     */
    async updateSprayConfiguration(spray) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/configuration/spray", spray);
        return result.data;
    },
    async getSettings(settingsName) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/settings/getsettings", settingsName);
        return result.data;
    },
    async updateSettings(settings) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/settings/updatesettings", settings);
        return result.data;
    },
    async getBerriesForecastNoteAlertCategories() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/configuration/berriesforecastnotealertcategories");
        return result.data;
    },
    async addBerriesForecastNoteAlertCategory(berriesForecastNoteAlertCategory) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put("/configuration/berriesforecastnotealertcategory", berriesForecastNoteAlertCategory);
        return result.data;
    },

    async updateBerriesForecastNoteAlertCategory(berriesForecastNoteAlertCategory) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/configuration/berriesforecastnotealertcategory", berriesForecastNoteAlertCategory);
        return result.data;
    },
    async getTeams(plantID) {
        let uri = `/plantconfiguration/teams`;
        if (plantID) {
            uri = uri + `?plantID=${plantID}`;
        }

        const request = await baseApi.createHttpRequest();
        const result = await request.get(uri);
        return result.data;
    },
    async saveTeam(team) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/plantconfiguration/team", team);
        return result.data;
    },
    async getCompanies() {
        const request = await baseApi.createHttpRequest();
        const result = await request.get("/configuration/companies");
        return result.data;
    },
    async getRoleTypeCategories() {
        const request = await baseApi.createHttpRequest();
        const result = await request.get("/configuration/roleTypeCategories");
        return result.data;
    },
    async getRegions(){
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/configuration/regions");
        return result.data;
    }
    
}